export default "__VITE_ASSET__b658e50d__"